import close from './close.svg';
import logo from './logo.svg';
import pptlogo from './ppt_logo.svg';
import doclogo from './doc_logo.svg';
import pdflogo from './pdf_logo.svg';

export const CLOSE = close;
export const LOGO = logo;
export const PPT_LOGO = pptlogo;
export const PDF_LOGO = pdflogo;
export const DOC_LOGO = doclogo;
